import { AppState } from '../../app/state/AppState';
import { LayoutType } from '../state/LayoutType';

export function selectLayoutType(state: AppState): LayoutType {
  return state.layoutType;
}
